/* eslint-disable */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import NoData from "../svgIcons/NoData";
import Spinner from "../Spinner/Spinner";
import {
  getBillingCyclesAction,
  getBillingCyclesByAssistantAction,
} from "../../actions/billingCycle";
import BillingCycles from "./BillingCycles";

const BillingCycleList = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("profile"));
  const { billingCycles } = useSelector((state) => state.billingCycle);
  const isLoading = useSelector((state) => state.product.isLoading);

  useEffect(() => {
    if (user?.result?.role == "assistant") {
      dispatch(getBillingCyclesByAssistantAction(user?.result?._id));
    } else {
      dispatch(getBillingCyclesAction(user?.result?._id));
    }
  }, [dispatch]);

  if (!user) {
    history.push("/login");
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  if (billingCycles?.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
          margin: "80px",
        }}
      >
        <NoData />
        <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>
          {location.pathname == "/reports"
            ? "No Reports Data"
            : "No Reports History."}
        </p>
      </div>
    );
  }

  return (
    <div>
      <h1 style={{ textAlign: "center", marginTop: "2%" }}>
        {" "}
        {location.pathname == "/reports" ? "Reports" : "Reports History"}
      </h1>
      <div style={{ marginTop: "7%" }}>
        <BillingCycles billingCycles={billingCycles} />
      </div>
    </div>
  );
};

export default BillingCycleList;
